import React, { useState, useEffect } from 'react'
import { HashRouter as Router, Routes, Route } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import 'bootstrap/dist/css/bootstrap.min.css'

// Pages
import EventListing from './pages/EventListing'
import TicketSelection from './pages/TicketSelection'
import EmailVerification from './pages/EmailVerification'
import CartSummary from './pages/CartSummary'
import PaymentProcessing from './pages/PaymentProcessing'
import TicketDownload from './pages/TicketDownload'
import TicketHistory from './pages/TicketHistory'
import TermsOfService from './pages/TermsOfService'
import PrivacyPolicy from './pages/LegalPrivacy'

// Components
import Header from './components/Header'
import Footer from './components/Footer'

function App() {
  const { i18n } = useTranslation()
  const [isI18nReady, setIsI18nReady] = useState(false)

  useEffect(() => {
    // Check if i18next is already initialized
    if (i18n.isInitialized) {
      setIsI18nReady(true)
    } else {
      // Wait for i18next to be initialized
      i18n.on('initialized', () => {
        setIsI18nReady(true)
      })
    }

    // Cleanup listener on unmount
    return () => {
      i18n.off('initialized')
    }
  }, [i18n])

  // Show loading while i18next is initializing
  if (!isI18nReady) {
    return (
      <div className="App" style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        backgroundColor: '#f4f4f4'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: '3rem',
            height: '3rem',
            border: '4px solid #f3f3f3',
            borderTop: '4px solid #dc3545',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 1rem'
          }}></div>
          <p>Cargando...</p>
        </div>
      </div>
    )
  }

  return (
    <Router>
      <div className="App">
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<EventListing />} />
            <Route path="/tickets" element={<EventListing />} />
            <Route path="/event/:eventId/tickets" element={<TicketSelection />} />
            <Route path="/verify-email" element={<EmailVerification />} />
            <Route path="/cart" element={<CartSummary />} />
            <Route path="/payment" element={<PaymentProcessing />} />
            <Route path="/payment_processing" element={<PaymentProcessing />} />
            <Route path="/tickets/:orderId" element={<TicketDownload />} />
            <Route path="/history" element={<TicketHistory />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  )
}

export default App
